// extracted by mini-css-extract-plugin
module.exports = {"documenten_wrapper":"documenten_documenten_wrapper__Cx5Ov","voorblad":"documenten_voorblad__1Qi50"};